var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FeedbackButton',{ref:"button",attrs:{"color":_vm.color,"toggled":_vm.toggled,"label":_vm.label,"data-clipboard-text":_vm.content}})}
var staticRenderFns = []

export { render, staticRenderFns }